import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from "@material-ui/core/styles";

const CustomToolbar = (p) => {

    const classes = p.classes;

    return (
        <React.Fragment>
            <Tooltip title={'Adicionar permissão'}>
                <IconButton className={classes.iconButton} onClick={p.handleAdicionar}>
                    <AddIcon className={classes.deleteIcon} />
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );

};

export default withStyles((theme)=>({
    iconButton: {
        '&:hover': {
            color: theme.palette.primary.main
        },
    }
}),{ name: 'CustomToolbar'},)(CustomToolbar);